import TimeAgo from 'javascript-time-ago';

export const extractLastRefresh = (lastRefresh: string | Date, language: string, isUTC?: boolean) => {
  const timeAgo = new TimeAgo(language);

  try {
    let date = typeof lastRefresh === 'string' ? new Date(lastRefresh) : lastRefresh;

    if (isUTC && typeof lastRefresh === 'string' && !lastRefresh.includes('Z') && !lastRefresh.includes('+')) {
      date = new Date(lastRefresh + 'Z');
    }

    return timeAgo.format(date);
  } catch (e) {
    return undefined;
  }
};
